import * as React from 'react';

import AcademicTermsCard from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/AcademicTermsCard';
import { TermStatus } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/lib/academicTermTypes';
import type { UseCurriculum_EstimatedAcademicTermFragment as EstimatedAcademicTerm } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import { now } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';

type Props = {
  emptyTerms: EstimatedAcademicTerm[];
};

const currentTime = Number(now());

const EmptyTerms = ({ emptyTerms }: Props) => {
  return (
    <React.Fragment>
      {emptyTerms.map((termPlan) => {
        const inProgressTerm = termPlan.linkedTerm && new Date(termPlan.linkedTerm.startDate).getTime() < currentTime;
        return (
          <AcademicTermsCard
            key={termPlan.estimatedTermId}
            estimatedTermId={termPlan.estimatedTermId}
            explicitTermId={termPlan.linkedTerm?.id}
            termName={termPlan.estimatedTermName}
            courses={[]}
            termStatus={inProgressTerm ? TermStatus.IN_PROGRESS : TermStatus.NOT_STARTED}
            creditSummary={{ completed: 0, inProgress: 0, planned: 0 }}
          />
        );
      })}
    </React.Fragment>
  );
};

export default EmptyTerms;
